import { TJob } from "../../api/modules/Jobs/types";

export const getAvailableJobAddressCopy = (job: TJob) => {
  const { projectAddressZip, projectAddressCity, projectAddressState } = job;

  return `${projectAddressCity || ""} ${projectAddressState || ""} ${
    projectAddressZip || ""
  }`;
};
